import enMessages from './src/intl/messages/en_US.json';
import nbMessages from './src/intl/messages/nb_NO.json';
import nnMessages from './src/intl/messages/nn_NO.json';

export const utilsMessages = {
    nb: nbMessages,
    nn: nnMessages,
    en: enMessages,
};

export {
    filteredListEØSCountries,
    createCountryOptions,
    countryIsMemberOfEøsOrEfta,
    getAlpha3Code,
    getCountryName,
    getLocaleKey,
} from './src/countryUtils';
export { omitOne, omitMany, erLikUansettRekkefølge } from './src/objectUtils';
export { redirect } from './src/loginUtils';

export { useAbortSignal } from './src/hooks/useAbortSignal';
export { useDocumentTitle } from './src/hooks/useDocumentTitle';
export { useBeforeUnload } from './src/hooks/useBeforeUnload';
export { useScrollBehaviour } from './src/hooks/useScrollBehaviour';
export { useMedia } from './src/hooks/useMedia';
export { trimNumberValue, getFloatFromString, getNumberFromNumberInputValue } from './src/numberUtils';
export {
    capitalizeFirstLetter,
    capitalizeFirstLetterInEveryWordOnly,
    getNavnGenitivEierform,
    replaceInvisibleCharsWithSpace,
    formatOppramsing,
} from './src/stringUtils';
export { getFamiliehendelsedato, getFamiliesituasjon, sorterPersonEtterEldstOgNavn } from './src/barnUtils';
export { formatCurrencyWithKr, formatCurrency } from './src/currencyUtils';
export { encodeToBase64, decodeBase64, compressToUrl, decompressFromUrl } from './src/urlEncodingUtils';
export { erLokaltEllerDev } from './src/miljoUtils';
export { getLenker } from './src/lenker';
export {
    getBokmålLocale,
    getLocaleForApi,
    getLocaleFromSessionStorage,
    getNynorskLocale,
    setLocaleInSessionStorage,
} from './src/localeUtils';
export {
    formatDate,
    formatDateIso,
    formatDateExtended,
    formatDateShortYear,
    formatDateMedUkedag,
    formatDateShortMonth,
    formatDateMedUkedagShortMonth,
    formatTime,
    dagenFør,
    treUkerSiden,
    femMånederSiden,
    fireUkerSiden,
    tiMånederSidenDato,
    erMyndig,
    halvannetÅrSiden,
    etÅrSiden,
    enMånedSiden,
    niMånederFremITid,
    isISODateString,
    ISOStringToDate,
    dateToISOString,
    dateIsSameOrAfter,
    dateIsSameOrBefore,
    formaterDatoUtenDag,
} from './src/dateUtils';

export { Uttaksdagen, erUttaksdag } from './src/uttak/Uttaksdagen';
export { Uttaksperioden } from './src/uttak/Uttaksperioden';
export { erFødtFørUke33, getAntallVirkedagerFraFødselTilTermin } from './src/uttak/prematurUtils';
export { Tidsperioden } from './src/Tidsperioden';
export * from './src/cookieUtils';
export { formatMånedÅr, periodFormat } from './src/periodUtils';
export { vedleggNedlastingsnavn } from './src/vedleggUtils';
export { barnehagestartDato, beregnBarnehagestartDato } from './src/barnehagestartUtils';
